<template>
	<div class="address">
		<div class="btnbox">
			<el-button type="primary" size="small" @click="onadd()">新增地址</el-button>
		</div>
		<div class="tablebox">
			<div class="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="name" label="姓名" fixed="left" align="center" header-align="center" min-width="100px">
					</el-table-column>
					<el-table-column prop="mobile" label="手机号" align="center" header-align="center" min-width="150px">
					</el-table-column>
					<el-table-column label="地址" align="center" header-align="center" min-width="350px">
						<template slot-scope="scope">
							<div>
								<p>{{scope.row.province_str}} / {{scope.row.city_str}} / {{scope.row.area_str}} {{scope.row.address}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="weight" label="排序" align="center" header-align="center" width="50px">
					</el-table-column>
					<el-table-column label="操作" fixed="right" align="center" header-align="center" width="80px">
						<template slot-scope="scope">
							<div class="operation_i">
								<span @click="onupdate(scope.row)">编辑</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
				:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
				@current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>
		
		<el-dialog :title="ruleForm.id == 0?'新增地址':'编辑地址'" :visible.sync="show" width="600px" :before-close="onclose">
			<div class="forms" v-if="show">
				<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
					<el-form-item label="姓名" prop="name">
						<el-input placeholder="请输入姓名" v-model="ruleForm.name">
						</el-input>
					</el-form-item>
					<el-form-item label="手机号" prop="mobile">
						<el-input placeholder="请输入手机号" v-model="ruleForm.mobile">
						</el-input>
					</el-form-item>
					<el-form-item label="省市区" prop="areaData">
						<el-cascader :props="props" v-model="ruleForm.areaData" :options="regionData" style="width: 100%;" placeholder="请选择省市区"></el-cascader>
					</el-form-item>
					<el-form-item label="详细地址" prop="address">
						<el-input type="textarea" placeholder="请输入详细地址" v-model="ruleForm.address" :rows="2">
						</el-input>
					</el-form-item>
					<el-form-item label="排序" prop="weight">
						<el-input placeholder="请输入排序" v-model="ruleForm.weight">
						</el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose">取消</el-button>
				<el-button type="primary" @click="onsub()">确定</el-button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	import {
		regionData
	} from 'element-china-area-data'
	export default {
		name: 'Address',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				
				show: false,
				ruleForm: {
					id: 0,
					name: "",
					mobile: "",
					province: "",
					city: "",
					area: "",
					address: "",
					areaData: [],
					weight: ""
				},
				rules: {
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					mobile: [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					}],
					areaData: [{
						required: true,
						message: '请选择省市区',
						trigger: 'change'
					}],
					address: [{
						required: true,
						message: '请输入详细地址',
						trigger: 'blur'
					}],
				},
				regionData: [],
				props: {
					value: 'label', 
					label: 'label',
					children: 'children'
				}
			}
		},
		
		mounted() {
			this.onlist();
			this.regionData = regionData;
		},
		
		methods: {
			handleCurrentChange() {
				this.onlist();
			},
		
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},
		
			onlist() {
				var obj = {};
				obj.page = this.page;
				obj.limit = this.pageSize;
		
				this.$axios.post('api/user/user_address_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onadd() {
				this.show = true;
			},
			
			onclose() {
				this.show = false;
				this.ruleForm = {
					id: 0,
					name: "",
					mobile: "",
					province: "",
					city: "",
					area: "",
					address: "",
					areaData: [],
					weight: ""
				};
			},
			
			onsub() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						var obj = JSON.parse(JSON.stringify(this.ruleForm));
						obj.province = obj.areaData[0];
						obj.city = obj.areaData[1];
						obj.area = obj.areaData[2];
						this.$axios.post('api/user/user_address_save', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('操作成功');
								this.onclose();
								this.onlist();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},
			
			onupdate(obj) {
				for (let key in this.ruleForm) {
					this.ruleForm[key] = obj[key];
				}
				this.ruleForm.areaData = [];
				this.ruleForm.areaData.push(this.ruleForm.province);
				this.ruleForm.areaData.push(this.ruleForm.city);
				this.ruleForm.areaData.push(this.ruleForm.area);
				this.show = true;
			}
		}
	}
</script>

<style scoped lang="less">
	.address {
		height: 100%;
	}
	
	.tablebox {
		height: calc(100% - 104px);
	}
	
	.tablediv {
		height: 100%;
	}
	
	/deep/ .el-select {
		width: 400px;
	}
	
	/deep/ .el-input {
		width: 400px;
	}
	
	/deep/ .el-textarea {
		width: 400px;
	}
</style>


// WEBPACK FOOTER //
// src/components/buyer/address.vue